import React, { createContext, useState, useRef, useEffect, useContext } from 'react'
import {
  doc, setDoc, getDocs, query, collection, where, collectionGroup,
  deleteDoc, getDoc
} from "firebase/firestore";
import { auth, db } from '../Firebase/firebase';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export const ContextSheet = createContext();

export const SheetContext = (props) => {

  const [tableData, setTableData] = useState([]);
  const [sheetId, setSheetId] = useState([]);
  const [uniqueSheetName, setUniqueSheetName] = useState([]);
  const [firebaseData, setFirebaseData] = useState([]);
  const [sheetNameSelect, setSheetNameSelect] = useState('');
  const [checked, setChecked] = useState(false);
  const [userFullName, setUserFullName] = useState([]);
  const [usersUid, setUsersUid] = useState([]);
  const [errorTextField, setErrorTextField] = useState(false);
  const [show, setShow] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);
  const [statusMsg, setStatusMsg] = useState(null);
  const [userSelected, setUserSelected] = useState([]);
  const [singleUser, setSingleUser] = useState([]);
  const [assignUsers, setAssignUsers] = useState([]);
  const [removeUsers, setRemoveUsers] = useState([]);
  const [sheetCreatedUser, setSheetCreatedUser] = useState([]);
  const [sheetCreatedBy, SetSheetCreatedBy] = useState([]);
  const [sheetGenerateById, setSheetGenerateById] = useState([]);
  const [createdDate, setCreatedDate] = useState([]);
  const [fetchCreatedUser, setFetchCreatedUser] = useState([]);
  const [fetchDate, setFetchDate] = useState([]);
  const [updateMsg, setUpdateMsg] = useState(null);
  const [updatedName, setUpdatedName] = useState(null);
  const [updatedNameStatus, setUpdatedNameStatus] = useState(null);
  const [roleUser, setRoleUser] = useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const sheetName = useRef(null);

  // console.log("CheckBox", checked);

  let usersList = [];

  useEffect(() => {

    const PostSheetId = async () => {

      const docRef = collectionGroup(db, "SheetsName");
      const getUsersList = query(docRef);
      const querySnapshot = await getDocs(getUsersList);
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const DocData = doc.data();
        // setFirebaseData(current => [...current, DocData]);

        setUniqueSheetName(current => [...current, doc.id]);

        sheetCreatedBy.map((item) => {
          setSheetGenerateById(item.id);
        })

      });

    }
    PostSheetId();


  }, [sheetNameSelect, sheetName])



  useEffect(() => {

    // tableData.Sheet = "sheet";
    let arraySheet = [];


    auth.onAuthStateChanged(async (user) => {
      if (user) {
        // User logged in already or has just logged in.
        // console.log(user.uid);
        // setUsersUid([...usersUid, user.uid]);
        setSingleUser(user.uid);
        // setUsersUid([...usersUid, singleUser]);
      } else {
        // User not logged in or has just logged out.
      }
      // setUsersUid([...usersUid, user.uid]);

      let getToken = sessionStorage.getItem('tokenRole');
      // console.log(getToken);

      let getQuery;
      let personalQuery;


      if (getToken === "user") {

        const docRef = collection(db, `Balance-Sheets/${user.uid}/SheetsName`);
        getQuery = query(docRef, where("isInActive", "==", false));
      }
      else {
        // const docRef = collectionGroup(db, "SheetsName");

        const personalDocRef = collection(db, `Balance-Sheets/${user.uid}/SheetsName`);
        const docRef = collectionGroup(db, `SheetsName`);
        getQuery = query(docRef, where("Role", "==", "user"));
        personalQuery = query(personalDocRef);
        const querySnapshot2 = await getDocs(personalQuery);

        // const docRef = collection(db, "Balance-Sheets");
        // getQuery = query(docRef);

        querySnapshot2.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          const DocData = doc.data();


          setFirebaseData(current => [...current, DocData]);

          arraySheet.push(doc.id);

          let uniqueChars = [...new Set(arraySheet)];

          setSheetId(uniqueChars);

        });

      }

      // console.log("dada", getQuery);
      const querySnapshot = await getDocs(getQuery);


      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const DocData = doc.data();


        setFirebaseData(current => [...current, DocData]);

        arraySheet.push(doc.id);

        let uniqueChars = [...new Set(arraySheet)];

        setSheetId(uniqueChars);

      });




      const userRef = collection(db, 'users');
      const q2 = query(userRef, where("Role", "in", ["user"]));
      const snapshot = await getDocs(q2);
      snapshot.forEach(doc => {
        // console.log(doc.id, '=>', doc.data().FullName);
        setUserFullName(current => [...current, { id: doc.id, FullName: doc.data().FullName }]);

      });

      const UserdocRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(UserdocRef);
      if (docSnap.exists()) {
        setSheetCreatedUser(current => [...current, { id: user.uid, FullName: docSnap.data().FullName }]);
        setUpdatedName(docSnap.data().FullName + " " + '(' + docSnap.data().Role + ')');

      }



    })





  }, [])


  const updateConfirmBoxBtn = () => {


    auth.onAuthStateChanged(async (user) => {

      const sheetNameValue = sheetName.current.value;

      if (user) {
        // User logged in already or has just logged in.

      } else {
        // User not logged in or has just logged out.
      }
      let getToken = sessionStorage.getItem('tokenRole');


      for (var i = 0; i < tableData.length; i++) {

        tableData[i].balanceRs = parseFloat(tableData[i].cashAdd) - parseFloat(tableData[i].expense)

        if (i > 0) {
          tableData[i].balanceRs = tableData[i].balanceRs - tableData[i - 1].balanceRs
        }

      }

      if (uniqueSheetName.includes(sheetNameValue) && sheetNameSelect.length === 0) {
        handleClick();
        setErrorTextField(true);
        setAlertMsg('error');
        setStatusMsg('This SheetName is already taken !!');

      }
      else if (tableData.length === 0) {
        handleClick();
        setAlertMsg('error');
        setStatusMsg('Table is Empty!!');
      }

      else if (sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

        // user personal sheet

        //confirmBox

        confirmAlert({
          title: "Are You Sure ?",
          message: "Are You Sure You Want To Update This Sheet ?",
          buttons: [
            {
              label: "Yes",
              onClick: () => { triggerUpdateBtn() },
            },
            {
              label: "No"
            }
          ]

        });

      }

      else if (!sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

        //kisi or sheet

        // usersUid me set krde ge hm jis ne sheet create kri hogi !! 
        // usersUid mein jo users assign wo bhi ajeye gey !!!

        if (getToken !== 'user') {

          //confirmBox
          confirmAlert({
            title: "Are You Sure ?",
            message: "Are You Sure You Want To Update This Sheet ?",
            buttons: [
              {
                label: "Yes",
                onClick: () => { triggerUpdateBtn2() },
              },
              {
                label: "No"
              }
            ],
          });



        }

        else {
          handleClick();
          setAlertMsg('error');
          setStatusMsg("You Can't Update This Sheet !!");
        }




      }
      else if (sheetNameSelect.length === 0) {

        //if sheet is not selected !!

        usersUid.push(user.uid);

        setUsersUid([...usersUid]);

        usersUid.map(async (item, id) => {
          await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {

            SheetName: sheetNameValue,
            isInActive: checked,
            userAssign: JSON.stringify(assignUsers),
            SheetCreatedBy: JSON.stringify(sheetCreatedUser),
            SheetUpdatedBy: updatedName,
            createdAt: new Date(),
            tableData: JSON.stringify(tableData),
            Status: "CREATED",
            Role: getToken,

          });
        });
        handleClick();

        setAlertMsg('success');
        setStatusMsg('Sheet Added Successfull !!');

        const timeOut = setTimeout(() => {
          window.location.reload(false);
        }, 2050);

      }


      else {
        setErrorTextField(false);
        setShow(false);

      }

    });


  }

  const triggerUpdateBtn = () => {

    auth.onAuthStateChanged(async (user) => {

      const sheetNameValue = sheetName.current.value;

      if (user) {
        // User logged in already or has just logged in.

      } else {
        // User not logged in or has just logged out.
      }
      let getToken = sessionStorage.getItem('tokenRole');

      usersUid.push(user.uid);
      setUsersUid([...usersUid]);

      removeUsers.map(async (item) => {
        await deleteDoc(doc(db, `Balance-Sheets/${item.id}/SheetsName`, sheetNameValue));
      })


      usersUid.map(async (item) => {

        await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {

          SheetName: sheetNameValue,
          isInActive: checked,
          userAssign: JSON.stringify(assignUsers),
          SheetUpdatedBy: updatedName,
          createdAt: new Date(),
          SheetCreatedBy: JSON.stringify(fetchCreatedUser),
          tableData: JSON.stringify(tableData),
          Status: "UPDATED",
          Role: roleUser,

        });
      })
      handleClick();

      setAlertMsg('success');
      setStatusMsg('Sheet Update Successfull !!');


    });

    const TimeOut = setTimeout(() => {
      window.location.reload(false);
    }, 2050)


  }
  const triggerUpdateBtn2 = () => {

    const sheetNameValue = sheetName.current.value;

    usersUid.push(sheetGenerateById);
    setUsersUid([...usersUid]);

    removeUsers.map(async (item) => {
      await deleteDoc(doc(db, `Balance-Sheets/${item.id}/SheetsName`, sheetNameValue));
    })


    usersUid.map(async (item) => {
      await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {
        SheetName: sheetNameValue,
        isInActive: checked,
        userAssign: JSON.stringify(assignUsers),
        SheetUpdatedBy: updatedName,
        createdAt: new Date(),
        SheetCreatedBy: JSON.stringify(fetchCreatedUser),
        tableData: JSON.stringify(tableData),
        Status: "UPDATED",
        Role: roleUser,
      })
    })

    handleClick();

    setAlertMsg('success');
    setStatusMsg('Sheet Update Successfull !!');



    const TimeOut = setTimeout(() => {
      window.location.reload(false);
    }, 2050)
  }




  // const postSheet = () => {

  //   auth.onAuthStateChanged(async (user) => {

  //     const sheetNameValue = sheetName.current.value;

  //     if (user) {
  //       // User logged in already or has just logged in.

  //     } else {
  //       // User not logged in or has just logged out.
  //     }
  //     let getToken = sessionStorage.getItem('tokenRole');


  //     for (var i = 0; i < tableData.length; i++) {

  //       tableData[i].balanceRs = parseFloat(tableData[i].cashAdd) - parseFloat(tableData[i].expense)

  //       if (i > 0) {
  //         tableData[i].balanceRs = tableData[i].balanceRs - tableData[i - 1].balanceRs
  //       }

  //     }

  //     if (uniqueSheetName.includes(sheetNameValue) && sheetNameSelect.length === 0) {

  //       setErrorTextField(true);
  //       setAlertMsg('error');
  //       setStatusMsg('This SheetName is already taken !!');

  //     }
  //     else if (tableData.length === 0) {
  //       setAlertMsg('error');
  //       setStatusMsg('Table is Empty!!');
  //     }

  //     else if (sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

  //       // user personal sheet

  //       usersUid.push(user.uid);
  //       setUsersUid([...usersUid]);

  //       removeUsers.map(async (item) => {
  //         await deleteDoc(doc(db, `Balance-Sheets/${item.id}/SheetsName`, sheetNameValue));
  //       })


  //       usersUid.map(async (item) => {

  //         await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {

  //           SheetName: sheetNameValue,
  //           isInActive: checked,
  //           userAssign: JSON.stringify(assignUsers),
  //           SheetUpdatedBy: updatedName,
  //           createdAt: new Date(),
  //           SheetCreatedBy: JSON.stringify(fetchCreatedUser),
  //           tableData: JSON.stringify(tableData),
  //           Status: "UPDATED",
  //           Role: roleUser,

  //         });
  //       })

  //       setAlertMsg('success');
  //       setStatusMsg('Sheet Update Successfull !!');


  //       setTimeout(() => {
  //         window.location.reload(false);
  //       }, 2000);

  //     }

  //     else if (!sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

  //       console.log("removeUsers", removeUsers);
  //       //kisi or sheet

  //       // usersUid me set krde ge hm jis ne sheet create kri hogi !! 
  //       // usersUid mein jo users assign wo bhi ajeye gey !!!

  //       if (getToken !== 'user') {

  //         usersUid.push(sheetGenerateById);
  //         setUsersUid([...usersUid]);

  //         removeUsers.map(async (item) => {
  //           await deleteDoc(doc(db, `Balance-Sheets/${item.id}/SheetsName`, sheetNameValue));
  //         })


  //         usersUid.map(async (item) => {
  //           await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {
  //             SheetName: sheetNameValue,
  //             isInActive: checked,
  //             userAssign: JSON.stringify(assignUsers),
  //             SheetUpdatedBy: updatedName,
  //             createdAt: new Date(),
  //             SheetCreatedBy: JSON.stringify(fetchCreatedUser),
  //             tableData: JSON.stringify(tableData),
  //             Status: "UPDATED",
  //             Role: roleUser,
  //           })
  //         })

  //         setAlertMsg('success');
  //         setStatusMsg('Sheet Update Successfull !!');

  //         setTimeout(() => {
  //           window.location.reload(false);
  //         }, 2000);
  //         console.log("hi threreee super user");
  //       }

  //       else {
  //         setAlertMsg('error');
  //         setStatusMsg('You Cant Update This Sheet !!');
  //         console.log("hi threreee");
  //       }




  //     }
  //     else if (sheetNameSelect.length === 0) {

  //       console.log(" new sheet created");

  //       console.log("removeUsers", removeUsers);

  //       //if sheet is not selected !!

  //       usersUid.push(user.uid);

  //       setUsersUid([...usersUid]);

  //       usersUid.map(async (item, id) => {
  //         await setDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue), {

  //           SheetName: sheetNameValue,
  //           isInActive: checked,
  //           userAssign: JSON.stringify(assignUsers),
  //           SheetCreatedBy: JSON.stringify(sheetCreatedUser),
  //           SheetUpdatedBy: updatedName,
  //           createdAt: new Date(),
  //           tableData: JSON.stringify(tableData),
  //           Status: "CREATED",
  //           Role: getToken,

  //         });
  //       });

  //       setAlertMsg('success');
  //       setStatusMsg('Sheet Added Successfull !!');

  //       setTimeout(() => {
  //         window.location.reload(false);
  //       }, 2000);

  //     }


  //     else {
  //       setErrorTextField(false);
  //       setShow(false);

  //     }

  //   });


  // }


  const deleteConfirmBoxBtn = () => {


    auth.onAuthStateChanged(async (user) => {


      const sheetNameValue = sheetName.current.value;

      let getToken = sessionStorage.getItem('tokenRole');

      if (user) {
        // User logged in already or has just logged in.

      } else {
        // User not logged in or has just logged out.
      }
      if (sheetNameSelect.length === 0) {



        setErrorTextField(true);
        handleClick();
        setAlertMsg('warning');
        setStatusMsg('Please Select The Sheet You want To Delete !!');


      }
      else if (sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {
        //confirm Box
        confirmAlert({
          title: "Are You Sure ?",
          message: "Are You Sure You Want To Delete This Sheet ?",
          buttons: [
            {
              label: "Yes",
              onClick: () => { triggerDeleteBtn() },
            },
            {
              label: "No"
            }
          ],
        });


      }
      else if (!sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

        if (getToken !== 'user') {

          //confirmBox

          confirmAlert({
            title: "Are You Sure ?",
            message: "Are You Sure You Want To Delete This Sheet ?",
            buttons: [
              {
                label: "Yes",
                onClick: () => { triggerDeleteBtn2() },
              },
              {
                label: "No"
              }
            ],
          });


        }

        else {
          handleClick();
          setAlertMsg('error');
          setStatusMsg("You Can't Delete This Sheet !!");
        }




      }
      else {
        setErrorTextField(false);
      }


    })



  }
  const triggerDeleteBtn = () => {

    const sheetNameValue = sheetName.current.value;

    auth.onAuthStateChanged(async (user) => {

      usersUid.push(user.uid);
      setUsersUid([...usersUid]);
      usersUid.map(async (item) => {
        await deleteDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue));
      });
      handleClick();
      setAlertMsg('success');
      setStatusMsg('Sheet Delete Successfull !!');



    })

    const timeOut = setTimeout(() => {
      window.location.reload(false);
    }, 2030);



  }

  const triggerDeleteBtn2 = () => {

    const sheetNameValue = sheetName.current.value;

    usersUid.push(sheetGenerateById);
    setUsersUid([...usersUid]);


    usersUid.map(async (item) => {
      await deleteDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue));
    });

    handleClick();
    setAlertMsg('success');
    setStatusMsg('Sheet Delete Successfull !!');



    const timeOut = setTimeout(() => {
      window.location.reload(false);
    }, 2030);


  }


  // const deleteSheet = () => {



  //   auth.onAuthStateChanged(async (user) => {

  //     const sheetNameValue = sheetName.current.value;

  //     let getToken = sessionStorage.getItem('tokenRole');


  //     if (user) {
  //       // User logged in already or has just logged in.

  //     } else {
  //       // User not logged in or has just logged out.
  //     }

  //     if (sheetNameSelect.length === 0) {

  //       setErrorTextField(true);
  //       setAlertMsg('warning');
  //       setStatusMsg('Please Select The Sheet You want To Delete !!');


  //     }
  //     else if (sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {

  //       usersUid.push(user.uid);
  //       setUsersUid([...usersUid]);
  //       usersUid.map(async (item) => {
  //         await deleteDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue));
  //       });
  //       setAlertMsg('success');
  //       setStatusMsg('Sheet Delete Successfull !!');

  //       setTimeout(() => {
  //         window.location.reload(false);
  //       }, 2000);

  //     }
  //     else if (!sheetGenerateById.includes(user.uid) && sheetNameSelect.length !== 0) {
  //       if (getToken !== 'user') {

  //         usersUid.push(sheetGenerateById);
  //         setUsersUid([...usersUid]);
  //         usersUid.map(async (item) => {
  //           await deleteDoc(doc(db, `Balance-Sheets/${item}/SheetsName`, sheetNameValue));
  //         });

  //         setAlertMsg('success');
  //         setStatusMsg('Sheet Delete Successfull !!');

  //         setTimeout(() => {
  //           window.location.reload(false);
  //         }, 2000);

  //       }
  //       else {
  //         setAlertMsg('error');
  //         setStatusMsg("You Can't Delete This Sheet !!");
  //       }


  //     }

  //     else {
  //       setErrorTextField(false);


  //     }
  //   })

  // }


  return (

    <ContextSheet.Provider

      value={{
        // postSheet,
        tableData,
        setTableData,
        sheetName,
        sheetId,
        firebaseData,
        setChecked,
        checked,
        setSheetNameSelect,
        sheetNameSelect,
        userFullName,
        setUsersUid,
        uniqueSheetName,
        setUniqueSheetName,
        errorTextField,
        setShow,
        show,
        alertMsg,
        statusMsg,
        setUserSelected,
        userSelected,
        // deleteSheet,
        singleUser,
        setAssignUsers,
        setRemoveUsers,
        SetSheetCreatedBy,
        sheetCreatedBy,
        setCreatedDate,
        createdDate,
        setFetchCreatedUser,
        setFetchDate,
        setUpdateMsg,
        updateMsg,
        setUpdatedNameStatus,
        updatedNameStatus,
        setRoleUser,
        updateConfirmBoxBtn,
        handleClick,
        handleClose,
        open,
        deleteConfirmBoxBtn,
      }}

    >

      {props.children}

    </ContextSheet.Provider>
  )

}